const MAX_CONCURRENT_UPLOADS = 3;

// Uploads share one connection's bandwidth; running them all at once makes
// every link arrive late together instead of the first ones arriving early.
// Module-level so the limit holds across Home remounts, since in-flight
// uploads outlive the route.
const queue = [];
let active = 0;

function finishUpload() {
  active--;
  pump();
}

function pump() {
  while (active < MAX_CONCURRENT_UPLOADS && queue.length > 0) {
    const start = queue.shift();
    active++;
    start(finishUpload);
  }
}

// `start` begins the upload and must call the `done` it's given exactly once
// when the request settles.
export function enqueueUpload(start) {
  queue.push(start);
  pump();
}

// Queued uploads carry the session token they were queued with, so they're
// dropped whenever the session changes. In-flight uploads are left to finish.
export function clearUploadQueue() {
  queue.length = 0;
}
